import { AuthGuard } from '@/router/guards/AuthGuard.js'
import SubmitDataPage from '@/views/Data/SubmitDataPage.vue'
import DataSubmissionsPage from '@/views/Data/DataSubmissionsPage.vue'

export default [
	{
		path: '/data/submit-data',
		name: 'data.submit-data',
		component: SubmitDataPage,
		meta: {
			authGuard: AuthGuard.RequireDataUpload,
			title: 'Data | Submit Data'
		}
	},
	{
		path: '/data/data-submissions',
		name: 'data.data-submissions',
		component: DataSubmissionsPage,
		meta: {
			authGuard: AuthGuard.RequirePermissions,
			title: 'Data | Submissions',
			// All permissions here must be present under getters in authStore.js
			// 'ands' must all be true
			// 'ors' must have at least one that is true
			permissions: {
				ands: [
					'isLoggedIn'
				],
				ors: [
					'isPortalAdmin',
					'canUploadData',
					'canDownloadData',
					'canViewAllOrgFiles'
				]
			}
		}
	}
]